// @flow
import React from 'react';

import SearchConsignation from 'Api/Search/consignation';
import Layout from 'pages/Avila/Consignation/List/layout'
import SearchModal from './SearchModal';


type Props = {
    onClose: any => any,
    actions: Array<any>,
    filterData: Array<any>
}

export default ({
    onClose,
    actions = [],
    filterData = [],
}: Props) => {


    return (
        <SearchModal
            title={"Consignations"} onClose={onClose}
            actions={actions}
            filterData={filterData}
            searchFunction={async query => {

                const consignations = await SearchConsignation({ data: {emprunteur : query} })

                return consignations.data;
            }}

            renderList={({ data, actions }) => {
                return (
                    <Layout data={data} filterData={filterData} actions={actions} />
                )
            }}
        />
    );
}